import React, { Suspense } from 'react';

export const HomeComponent = React.lazy(() => import('./Home'));

export const Home = (props) => (
  <Suspense fallback={null}>
    <HomeComponent {...props} />
  </Suspense>
);
